import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import type { OperatorRole } from '../api/types'

const ROLE_BADGE_CLASS: Record<OperatorRole, string> = {
  ADMIN: 'role-badge-admin',
  OPERATOR: 'role-badge-operator',
  VIEWER: 'role-badge-viewer',
}

export function TopBar() {
  const auth = useAuth()
  const navigate = useNavigate()
  const [busy, setBusy] = useState(false)

  if (auth.status !== 'authenticated') return null

  const handleSignOut = async () => {
    setBusy(true)
    try {
      await auth.signOut()
    } finally {
      setBusy(false)
      navigate('/login', { replace: true })
    }
  }

  return (
    <header
      className="flex h-14 items-center justify-between border-b border-stone-200
                 bg-white px-6"
    >
      <div className="text-sm text-stone-500">Operator console</div>
      <div className="flex items-center gap-3">
        <div className="text-right">
          <div className="text-sm font-medium text-stone-900">
            {auth.operator.display_name || auth.operator.email}
          </div>
          <div className="text-xs text-stone-500">{auth.operator.email}</div>
        </div>
        <span className={ROLE_BADGE_CLASS[auth.operator.role]}>
          {auth.operator.role}
        </span>
        <button
          type="button"
          onClick={handleSignOut}
          disabled={busy}
          className="btn-secondary text-sm"
        >
          Sign out
        </button>
      </div>
    </header>
  )
}
